import { createSlice } from "@reduxjs/toolkit";
import { getLeadList } from "../../reduxApi/admin/LeadReduxApi";

const leadSlice = createSlice({
    name: 'lead',
    initialState: {
        status: 'idle', // Fixed typo: 'idel' -> 'idle'
        isFiltered: false,
        lead: [],
        page: 1,
        size: 30,
        message: '',
        success: false
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteLeadAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.lead.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.lead.splice(index, 1);
                }
            });
        },
        updateLeadAction: (state, action) => {
            const index = state.lead.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index !== -1) {
                state.lead[index] = action.payload; // Direct assignment instead of splice
            }
        },
        addLeadAction: (state, action) => {
            const temp = action.payload;
            temp.ROWID = action.payload.ROWID;
            state.lead.unshift(temp); // Don't wrap in { leads: }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLeadList.pending, (state) => {
                state.status = 'pending';
                state.success = false;
            })
            .addCase(getLeadList.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.success = action.payload.success;
                state.message = action.payload.message;
                state.page = action.payload.page;
                state.size = action.payload.size;
                state.lead = action.payload.leads || [];
            })
            .addCase(getLeadList.rejected, (state, action) => {
                state.status = 'rejected';
                state.success = false;
                state.message = action.payload || 'Failed to fetch leads';
            });
    }
});

export const { deleteLeadAction, updateLeadAction, addLeadAction, setFilteredStatus } = leadSlice.actions;
export default leadSlice.reducer;